/**
 * Require $.
 */

var $ = require('jquery');

module.exports = function () {
    document.addEventListener('DOMContentLoaded', function () {
        if (!window.jQuery) return 
        
        setTimeout(function(){
            $('form.checkout_coupon').slideToggle( 400, function() {
                $( '.checkout_coupon' ).find( ':input:eq(0)' ).trigger( 'focus' );
            });
        }, 50);
    }, false);
}
